import axios from 'axios'
const baseUrl = process.env.VUE_APP_API_URL_ORDERH5
axios.defaults.baseURL = baseUrl

const service = axios.create({
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8',
  },
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data.data
    console.log('🚀 ~ res:', res)
    return res
  },
  error => {
    console.log('🚀 ~ error:', error)
  }
)
export default service
